import React, { useState, useEffect } from "react";
import Pagination from "react-responsive-pagination";
import { toast } from "react-toastify";
import axios from "utils/axios";
import { mintNFT } from "utils/wallet";
import { scrollToTop } from "utils/utils";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Pendings = () => {
  const [formData, setFormData] = useState<Array<any>>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [showCount, setShowCount] = useState<number>(10);
  const navigate = useNavigate();

  const loadPage = async () => {
    try {
      const response = await axios.get(
        `/api/account/read/${showCount}/${currentPage}`
      );
      setTotalPages(Math.ceil(response.data.count / showCount));
      setFormData(response.data.rows);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    scrollToTop();
    loadPage();
  }, [currentPage, showCount]); //eslint-disable-line

  const handlePageChange = (e: number) => {
    setCurrentPage(e);
  };
  const handleCountChange = (e: number) => {
    setCurrentPage(1);
    setShowCount(e);
  };

  const handleAccept = async (val: any) => {
    toast.info("Please wait, It may takes a while");
    const result = await mintNFT(val);
    result === true && handleDelete(val.id);
  };

  const handleDelete = async (id: number) => {
    Swal.fire({
      title: "<h6>Are you sure you won't accept this account?</h6>",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: `Confirm`,
      denyButtonText: `Cancel`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        try {
          const result = await axios.delete(`/api/account/delete/${id}`);
          loadPage();
          toast.success(result.data.message);
          navigate("/dashboard");
        } catch (error: any) {
          toast.error(error.response.data.message);
        }
      } else if (result.isDenied) {
        return;
      }
    });
  };

  return (
    <>
      <div className="main-text text-right sm:text-center">
        <span
          className={`cursor-pointer ${
            showCount === 10 ? "text-button font-extrabold" : ""
          }`}
          onClick={() => handleCountChange(10)}
        >
          10
        </span>
        {" | "}
        <span
          className={`cursor-pointer ${
            showCount === 25 ? "text-button font-extrabold" : ""
          }`}
          onClick={() => handleCountChange(25)}
        >
          25
        </span>
        {" | "}
        <span
          className={`cursor-pointer ${
            showCount === 100 ? "text-button font-extrabold" : ""
          }`}
          onClick={() => handleCountChange(100)}
        >
          100
        </span>
      </div>
      <div className="grid gap-[8px]">
        {formData?.map((account, index) => (
          <div
            className="px-[20px] py-[8px] flex sm:flex-col items-center justify-between sm:items-start bg-gray main-text border-solid border-[1.5px] border-[#bdbdbd] rounded-sm shadow-md hover:shadow-none cursor-default"
            key={index}
          >
            <div className="flex gap-[16px] items-center">
              <img
                src={account.media}
                alt="art"
                className="w-11 h-11 rounded-full"
              />
              <span>
                [{account.title}] [{account.userType}]
                <br />
                Organization: {account.organization}
              </span>
            </div>
            <div className="flex sm:ml-auto sm:mt-[20px] gap-2">
              <CheckOutlinedIcon
                onClick={() => handleAccept(account)}
                className="cursor-pointer text-[#444444]"
              />
              <DeleteOutlinedIcon
                onClick={() => handleDelete(account.id)}
                className="cursor-pointer text-[#444444]"
              />
            </div>
          </div>
        ))}
        <Pagination
          total={totalPages}
          current={currentPage}
          onPageChange={(page) => handlePageChange(page)}
          maxWidth={300}
        />
      </div>
    </>
  );
};

export default Pendings;
